import {
  borderRadius,
  borderWidth,
  fontSize,
  fontWeight,
  letterSpacing,
  lineHeight,
  spacing,
} from "./common";

export const defaultDark = {
  spacing,
  colors: {
    background: {
      accent1: "hsla(215, 100%, 62%, 1)",
      accent1Hovered: "hsla(215, 100%, 51%, 0.16)",
      accent1Pressed: "hsla(215, 100%, 51%, 0.32)",
      accent1Focused: "hsla(215, 100%, 51%, 0.32)",
      buttonCriticalDisabled: "hsla(204, 16%, 94%, 1)",
      buttonCriticalPrimary: "hsla(11, 100%, 56%, 1)",
      buttonCriticalPrimaryFocused: "hsla(11, 100%, 42%, 1)",
      buttonCriticalPrimaryHovered: "hsla(11, 100%, 42%, 1)",
      buttonCriticalPrimaryPressed: "hsla(11, 100%, 29%, 1)",
      buttonDefaultDisabled: "hsla(211, 32%, 21%, 1)",
      buttonDefaultPrimary: "hsla(0, 0%, 100%, 1)",
      buttonDefaultPrimaryFocused: "hsla(210, 24%, 86%, 1)",
      buttonDefaultPrimaryHovered: "hsla(211, 24%, 86%, 1)",
      buttonDefaultPrimaryPressed: "hsla(211, 16%, 68%, 1)",
      buttonDefaultSecondary: "hsla(232, 17%, 18%, 1)",
      buttonDefaultSecondaryFocused: "hsla(211, 32%, 19%, 1)",
      buttonDefaultSecondaryHovered: "hsla(211, 32%, 19%, 1)",
      buttonDefaultSecondaryPressed: "hsla(211, 24%, 26%, 1)",
      buttonDefaultTertiary: "hsla(180, 4%, 15%, 0)",
      buttonDefaultTertiaryFocused: "hsla(0, 0%, 100%, 0.06)",
      buttonDefaultTertiaryHovered: "hsla(0, 0%, 100%, 0.06)",
      buttonDefaultTertiaryPressed: "hsla(0, 0%, 100%, 0.12)",
      critical1: "hsla(11, 100%, 96%, 1)",
      critical1Focused: "hsla(11, 100%, 46%, 0.2)",
      critical1Hovered: "hsla(11, 100%, 46%, 0.2)",
      critical1Pressed: "hsla(11, 100%, 46%, 0.32)",
      critical2: "hsla(11, 100%, 56%, 1)",
      default1: "hsla(232, 17%, 18%, 1)",
      default1Focused: "hsla(0, 0%, 100%, 0.06)",
      default1Hovered: "hsla(0, 0%, 100%, 0.06)",
      default1Pressed: "hsla(0, 0%, 100%, 0.12)",
      default2: "hsla(231, 17%, 16%, 1)",
      default3: "hsla(211, 42%, 12%, 1)",
      defaultDisabled: "hsla(211, 32%, 21%, 1)",
      info1: "hsla(215, 100%, 62%, 1)",
      success1: "hsla(173, 100%, 32%, 1)",
      warning1: "hsla(42, 100%, 84%, 1)",
    },
    text: {
      accent1: "hsla(215, 100%, 83%, 1)",
      buttonCriticalDisabled: "hsla(212, 14%, 67%, 1)",
      buttonCriticalPrimary: "hsla(0, 0%, 100%, 1)",
      buttonDefaultPrimary: "hsla(212, 44%, 13%, 1)",
      buttonDefaultSecondary: "hsla(0, 0%, 100%, 1)",
      buttonDefaultTertiary: "hsla(0, 0%, 100%, 1)",
      critical1: "hsla(11, 100%, 82%, 1)",
      critical2: "hsla(11, 100%, 58%, 1)",
      default1: "hsla(0, 0%, 100%, 1)",
      default2: "hsla(230, 10%, 53%, 1)",
      defaultDisabled: "hsla(212, 19%, 39%, 1)",
      info1: "hsla(215, 100%, 83%, 1)",
      success1: "hsla(173, 79%, 62%, 1)",
      warning1: "hsla(36, 44%, 50%, 1)",
    },
    border: {
      accent1: "hsla(215, 100%, 39%, 1)",
      critical1: "hsla(11, 100%, 35%, 1)",
      default1: "hsla(210, 32%, 25%, 1)",
      default1Focused: "hsla(212, 24%, 32%, 1)",
      default1Hovered: "hsla(210, 32%, 25%, 1)",
      defaultDisabled: "hsla(231, 18%, 23%, 1)",
      default2: "hsla(211, 21%, 39%, 1)",
      info1: "hsla(210, 32%, 25%, 1)",
      success1: "hsl(173, 79%, 62%, 1)",
      warning1: "hsla(36, 44%, 50%, 1)",
    },
  },
  fontSize,
  borderRadius,
  lineHeight,
  fontWeight,
  letterSpacing,
  boxShadow: {
    defaultFocused: "0px 1px 1px 0px hsla(0, 0%, 0%, 0.32)",
    defaultHovered: "0px 2px 3px 0px hsla(0, 0%, 0%, 0.28)",
    defaultOverlay: "0px 3px 8px 0px hsla(0, 0%, 0%, 0.24)",
    defaultModal: "0px 8px 16px 0px hsla(0, 0%, 0%, 0.2)",
  },
  borderWidth,
};
